"use client";

import Quote from "@/components/Icons/Quote";
import TheApp from "@/components/Icons/TheApp";
import TheToolkit from "@/components/Icons/TheToolkit";
import Thinknado from "@/components/Icons/Thinknado";
import { Button } from "@/components/actions/Button";
import { wait } from "@/lib/helpers";
import Video from "../Video";
import { useState } from "react";
import { Camera, PlayCircle } from "react-feather";
import Popover from "../Popover";
import Link from "next/link";
import { FlipCard } from "@/components/actions/FlipCard";
import { appData } from "@/data/appData";
import VideoInline from "@/components/Video";
import { InlineVideo } from "@/components/components/InlineVideo";
import DeathToBoring from "@/components/components/DeathToBoring";
import Footer from "@/components/Footer";
import { If } from "react-haiku";

export default function UI({ daily = {}, user = {} }) {
  const [showVideo, setShowVideo] = useState(false);
  const [listenToTutorial1, setListenToTutorial1] = useState(false);
  const [listenToTutorial, setListenToTutorial] = useState(false);

  return (
    <>
      <section className="grid mx-auto gutter section-2 gap-12 border-b pb-24 pt-24">
        <div className="flex flex-col gap-6" id="app">
          <h2 className="text-[3rem] font-black">The App</h2>
          <p className="text-lg">
            You won’t know what it does until you try it! This is some big time
            fun. We could explain it all day and tell you how great it is and
            how it works but that won’t help, really it won’t. We can promise
            you this, it’s interactive (so silicon valley), it’s fast, it’s fun
            and you won’t regret it. Did I mention it’s free and comes with a
            money back guarantee. We will love you forever if you try it and let
            us know how you like it.
          </p>
          <Button href="/app" className="btn">
            <If isTrue={!user}>Sign In Today</If>
            <If isTrue={user}>Start a Session</If>
          </Button>
        </div>

        <div className="flex flex-col gap-6">
          <img src="/endurable.jpg" alt="The App" className="w-full" />
          <img src="/gorilla.png" alt="The App" className="w-full" />
          <p className="text-3xl font-bold">
            You'll sprout hair that's sexier than a flamenco-dancing lumberjack.
            Think better, or your money back!
          </p>
          {/* <Button
            href="#the-demo"
            className="btn"
            onClick={async () => {
              await wait(500);
              setListenToTutorial(true);
            }}
          >
            Play Demo
          </Button> */}
        </div>

        <div className="flex justify-center">
          <TheApp />
        </div>

        <div>
          <Quote />
          <div className="bg-[#E5E0CD] py-8 px-5">
            <p className=" italic text-2xl font-times">
              We all get stuck from time to time.  The Thinknado app is grease
              for new thinking, new ideas and gives you permission to explore
              the unconventional.
            </p>
          </div>
          <Quote flip />
        </div>
      </section>

      {/* <DeathToBoring /> */}

      <section className="skip-to-the-end grid gap-12 border-b  items-start relative z-10">
        <div className="stack w-full h-full relative">
          <VideoInline src="/Sall-e_walk-thru-neu-3_web.mp4" />

          <h2 className="type-6 absolute left-5 top-5 font-black text-white">
            Behold Your Guide Sall-e: Mastering the art of thinking wrong —
            solving problems with 0% accuracy and 100% inspiration.
          </h2>
        </div>

        <div className="stack gap-8 pb-10 pt-10 relative z-10 px-4 md:px-0 p-gutter-r">
          <header className="stack gap-2">
            <h2 className="type-4 font-black">A Spiraling Speculation</h2>
            <p>{daily?.intro}</p>
            {/* <p className="font-bold">
                  To make your mind whirl while initiating (or reminding) you of
                  the magical process that is Thinknado.
                </p> */}
          </header>

          <div className="py-4 border-tb stack">
            <h2 className="text-purple font-bold text-2xl">The Challenge</h2>
            <p>{daily?.challenge}</p>
          </div>

          <h2 className="text-purple font-bold text-2xl">The What If? Cards</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center w-full">
            <FlipCard
              color="black"
              cardTitle={daily?.whatIfWord}
              type="whatIf"
              slug="whatIf"
              data={appData.whatIfText || {}}
              value={daily?.whatIfWord}
              flipped={true}
              size="tiny"
              canFlip={false}
            />

            <FlipCard
              color="white"
              slug="whatIf2"
              cardTitle="Hope"
              type="image"
              data={appData.whatIfImages || {}}
              value={daily?.whatIfImage}
              flipped={true}
              size="tiny"
              canFlip={false}
            />
          </div>

          <div className="py-4 border-tb">
            <h2 className="text-purple font-bold text-2xl">The Idea</h2>
            <p>{daily?.idea}</p>
          </div>

          <p>{daily?.outro}</p>
          <Button href="/app" color="purple">
            <If isTrue={!user}>Sign In And Try It!</If>
            <If isTrue={user}>Start a Session</If>
          </Button>
        </div>
      </section>

      <section className="grid mx-auto gutter section-8 gap-12 border-b pb-24 pt-24">
        <div>
          <Quote />
          <div className="bg-[#E5E0CD] py-8 px-5">
            <p className=" italic text-2xl font-times">
              There are literally and figuratively no wrong answers. You simply
              can’t break anything. No one can get hurt!*
            </p>
            <p className="text-sm italic mt-10">
              * paper cuts can be a problem with the card deck
            </p>
          </div>
          <Quote flip />
        </div>
        <div>
          <InlineVideo
            src={"/videos/goat.mp4"}
            className="w-full object-contain aspect-[37/64]"
          />
        </div>
        <div className="type-6 font-black leading-[0.8] font-display">
          Total opposite guarantee: If your ideas are still boring, you owe us
          money. Cheques and small goats accepted.
        </div>
      </section>

      {/* <section className="grid mx-auto gutter section-9 gap-12 border-b pb-24 pt-24">
        <div className="flex flex-col gap-6">
          <h2 className="type-8 font-black leading-[0.8] break-anywhere">
            MONEY BACK GUARANTEE.
          </h2>

          <div className="border-tb py-4 flex flex-col gap-4 font-black font-display text-[2rem]">
            Okay, yeah, the base product is free... so sue us.
          </div>
        </div>
        <div>
          <iframe
            width="560"
            height="315"
            className="w-full h-full"
            loading="lazy"
            src="https://www.youtube.com/embed/d_jMkyRimCM?si=4_olsy2PYXb5LNJv"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </section> */}

      <Footer
        text="Drive your ideas further than a VW Bug on the moon!"
        src="/videos/goatOnTheMoon_web.mp4"
      />
    </>
  );
}
